<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Date"><br>
                                        <a-range-picker v-model="inputDate" format="MM-DD-YYYY" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :disabled="site_type != 'ho'">
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' > 
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}} 
                                    </button>
                                </div>
                            </div>
        
                            <base-checkbox class="mb-3" v-model="isShowZero">
                                Show BegBal and EndBal with zero amount
                            </base-checkbox>
        
                            <base-checkbox class="mb-3" v-model="isSeparateSite">
                                Separate Per Site
                            </base-checkbox>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;
                             <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <download-excel v-if="JsonData.length > 0" :data="JsonData" :name="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '')+`.xls`" class="float-right"  style=" width: 20%;">
                                <button class="btn btn-sm btn-success" style="border-radius: 24px; border:0px; width: 100%;" @click.prevent="clearJsonData"> Download excel </button> &nbsp; &nbsp;
                            </download-excel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import { getReportDescription } from '../../utilities';
    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputGroupBy: 'supplier_id',
                groupOptions: [
                    {key: 'supplier_id', value: 'Supplier'},
                    {key: 'brand_id', value: 'Brand'},
                    {key: 'department_id', value: 'Department'},
                    {key: 'section_id', value: 'Section'},
                    {key: 'category_id', value: 'Category'}
                ],
                inputSortBy: 'product_id',
                sortOptions: [
                    {key: 'product_id', value: 'Product Code'},
                    {key: 'barcode', value: 'Barcode'},
                    {key: 'name', value: 'Name or Description'}
                ],
                birSalesReports: [],
                isSeparateSite: false,
                isShowZero: false,

                currDate: moment().format("L_LT").split(":").join(";"),
                showSortInfo: 'asc',
                JsonData: [],
                accessRights:[],
                accessCostPriceRights:[],
                reportDescription: ''
            }
        },
        mounted: async function () {
            var component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
            this.accessRights = this.$attrs.access_rights || []
            this.accessCostPriceRights = this.$attrs.access_costprice_rights || []
        },
        computed: {
            ...mapState(['currentProfile' ,'endPoint']),
        },
        components:{
            VueJsonToCsv
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            formatNumber(num) {
               return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            openNotificationWithIcon(type, msg) {
                this.$notification[type]({
                    message: 'Export Error',
                    description: msg 
                });
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            generateReport: async function () {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }
                
                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let group_val = this.groupOptions.find(x => x.key === this.inputGroupBy).value

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'stock_activity_valuation?site_id=' + this.inputSite +
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                    '&isSeparate=' + this.isSeparateSite + '&group=' + this.inputGroupBy + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo +
                    '&isBalZero=' + this.isShowZero, null);
                let siteSpecific = get_request;

                if(siteSpecific.length > 0){
                    let doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'c3' });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    let header_top = [];
                    let header_detail = [];
                    
                    header_top.push(
                        {content: 'Product\nCode', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'Barcode', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'Description', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'Retail\nPrice', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'BegBal', rowSpan: 2, styles: {halign: 'center'}},
                        {content: 'IN', colSpan: 4, styles: {halign: 'center'}},
                        {content: 'OUT', colSpan: 4, styles: {halign: 'center'}},
                    )

                    header_detail.push(
                        {content: 'Receiving', styles: {halign: 'center'}},
                        {content: 'Transfer', styles: {halign: 'center'}},
                        {content: 'Returns', styles: {halign: 'center'}},
                        {content: 'ADJ', styles: {halign: 'center'}},
                        {content: 'Sales', styles: {halign: 'center'}},
                        {content: 'Transfers', styles: {halign: 'center'}},
                        {content: 'Returns', styles: {halign: 'center'}},
                        {content: 'ADJ', styles: {halign: 'center'}}
                    )

                    headers = [header_top, header_detail]
                    let product_array = []
                    let grand_beg_bal = 0
                    let grand_rr_cost = 0
                    let grand_ti_cost = 0
                    let grand_ret_cost = 0
                    let grand_adji_cost = 0
                    let grand_sales_cost = 0
                    let grand_to_cost = 0
                    let grand_pr_cost = 0
                    let grand_adjo_cost = 0

                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_beg_bal = 0
                            let total_rr_cost = 0
                            let total_ti_cost = 0
                            let total_ret_cost = 0
                            let total_adji_cost = 0
                            let total_sales_cost = 0
                            let total_to_cost = 0
                            let total_pr_cost = 0
                            let total_adjo_cost = 0
                            
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if (product_array.includes(reportLine.product_id) == false){
                                    product_array.push(reportLine.product_id)
                                }
                                
                                if(grouper == 'start'){
                                    let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [{content: grouper_name, colSpan: 3, styles: {halign: 'left', fontStyle: 'bold'}}];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                
                                let detail = []
                                detail.push(
                                    reportLine.product_id,
                                    reportLine.barcode,
                                    {content: reportLine.name, styles: {halign: 'left'}},
                                    this.convertToCurrency(Number(reportLine.retail_price), 'Y'),
                                    this.convertToCurrency(Number(reportLine.beg_bal)),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.rr_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.ti_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.ret_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.adji_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.sales_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.to_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.pr_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.adjo_cost)), 'Z')
                                )
                                reportData.push(Object.assign({}, detail))

                                total_beg_bal += Number(reportLine.beg_bal)
                                total_rr_cost += Number(reportLine.rr_cost)
                                total_ti_cost += Number(reportLine.ti_cost)
                                total_ret_cost += Number(reportLine.ret_cost)
                                total_adji_cost += Number(reportLine.adji_cost)
                                total_sales_cost += Number(reportLine.sales_cost)
                                total_to_cost += Number(reportLine.to_cost)
                                total_pr_cost += Number(reportLine.pr_cost)
                                total_adjo_cost += Number(reportLine.adjo_cost)

                                grand_beg_bal += Number(reportLine.beg_bal)
                                grand_rr_cost += Number(reportLine.rr_cost)
                                grand_ti_cost += Number(reportLine.ti_cost)
                                grand_ret_cost += Number(reportLine.ret_cost)
                                grand_adji_cost += Number(reportLine.adji_cost)
                                grand_sales_cost += Number(reportLine.sales_cost)
                                grand_to_cost += Number(reportLine.to_cost)
                                grand_pr_cost += Number(reportLine.pr_cost)
                                grand_adjo_cost += Number(reportLine.adjo_cost)

                                if(i == this.birSalesReports.length-1){
                                    let total_detail = []

                                    let total_display = "Grand Total"
                                    if(this.isSeparateSite == true){
                                        total_display = "Site Sub Total"
                                    }

                                    if(this.isSeparateSite == false){
                                        total_detail.push(
                                            {content: `Assortment : ${product_array.length}`, styles: {halign: 'left'}}, ""
                                        )
                                    } else {
                                        total_detail.push("", "")
                                    }

                                    total_detail.push(
                                        `${total_display} :`, "",
                                        this.convertToCurrency(total_beg_bal),
                                        this.addMaskValidation(this.convertToCurrency(total_rr_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_ti_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_ret_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_adji_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_sales_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_to_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_pr_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_adjo_cost), 'Z')
                                    )

                                    reportData.push(Object.assign({}, ["rowLine"]))
                                    reportData.push(Object.assign({}, total_detail))
                                }
                            }
                        }

                        if(x == siteSpecific.length-1 && this.isSeparateSite == true){
                            let total_detail = []

                            total_detail.push(
                                {content: `Assortment : ${product_array.length}`, styles: {halign: 'left'}}, "",
                                "Grand Total :", "",
                                this.convertToCurrency(grand_beg_bal),
                                this.addMaskValidation(this.convertToCurrency(grand_rr_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_ti_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_ret_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_adji_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_sales_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_to_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_pr_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_adjo_cost), 'Z')
                            )

                            reportData.push(Object.assign({}, ["rowLine"]))
                            reportData.push(Object.assign({}, total_detail))
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + group_val
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Stock Activity Valuation" + group_text)
                        doc.setFontType("normal");
                        doc.setFontSize(10);

                        let design_x = 440
                        let design_y = 315

                        if(this.isSeparateSite == true){
                            doc.text(design_x,20,siteSpecific[x].report_details[0].site_name,"right");
                        } else {
                            let site_text = ''
                            if(this.inputSite.length == 0){
                                site_text = 'All Sites'
                            } else {
                                let sites = this.inputSite
                                for (var s = 0; s < sites.length; s++) {
                                    if(s == 0){
                                        site_text += this.siteOptions.find(x => x.id === sites[s]).name
                                    } else {
                                        site_text += ', ' + this.siteOptions.find(x => x.id === sites[s]).name
                                    }
                                }
                            }
                            doc.text(design_x,20,site_text,"right");
                        }
                        doc.text(15,25,"For the Period of " + from_header + " to " + to_header)

                        let colStyles = {
                            0: {cellWidth: 30},
                            1: {cellWidth: 30},
                            2: {cellWidth: 65},
                            3: {cellWidth: 30},
                            4: {cellWidth: 30},
                            5: {cellWidth: 30},
                            6: {cellWidth: 30},
                            7: {cellWidth: 30},
                            8: {cellWidth: 30},
                            9: {cellWidth: 30},
                            10: {cellWidth: 30},
                            11: {cellWidth: 30},
                            12: {cellWidth: 30}
                        }

                        doc.autoTable({
                            startY: 35, 
                            head: headers, 
                            body: reportData, 
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            styles: {
                                cellPadding: 1.0, fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[2] == 'Grand Total :' || data.row.raw[2] == 'Site Sub Total :')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }
                        
                        doc.text(15,design_y,"Printed By: " + printed_by)
                        doc.text(design_x,design_y,"Stock Activity Valuation" + group_text, "right")

                        doc.text(15,design_y+5,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
                        doc.text(design_x,design_y+5,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                    }
                    window.open(URL.createObjectURL(doc.output("blob")))
                    // doc.save(`Stock_Activity_Valuation_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                }
                this.spinning= false;
            },
            generateFile: async function() {
                this.spinning= true;
                if(this.inputDate.length == 0){
                    this.openNotificationWithIcon('error', 'Please make sure to check your current filters.');
                    return
                }
                
                let from_header = this.inputDate[0].format('MMMM DD, YYYY')
                let to_header = this.inputDate[1].format('MMMM DD, YYYY')

                let group_val = this.groupOptions.find(x => x.key === this.inputGroupBy).value

                let get_request = await HTTPRequest.getRequest(this.endPoint + 'stock_activity_valuation?site_id=' + this.inputSite +
                    '&date_from=' + this.inputDate[0].format('YYYY-MM-DD HH:mm:ss') + '&date_to=' + this.inputDate[1].format('YYYY-MM-DD HH:mm:ss') +
                    '&isSeparate=' + this.isSeparateSite + '&group=' + this.inputGroupBy + '&order=' + this.inputSortBy + '&by=' + this.showSortInfo +
                    '&isBalZero=' + this.isShowZero, null);
                let siteSpecific = get_request;

                if(get_request.length > 0){
                    let headers = [];
                    let site_specific = [];
                    let header_top = [];
                    
                    header_top.push('Product Code','Barcode','Description','Retail Price','BegBal','Receiving IN','Transfer IN','Returns IN','ADJ IN','Sales OUT','Transfers OUT','Returns OUT','ADJ OUT')

                    headers = header_top
                    let product_array = []
                    let grand_beg_bal = 0
                    let grand_rr_cost = 0
                    let grand_ti_cost = 0
                    let grand_ret_cost = 0
                    let grand_adji_cost = 0
                    let grand_sales_cost = 0
                    let grand_to_cost = 0
                    let grand_pr_cost = 0
                    let grand_adjo_cost = 0


                    for(let x=0; x < siteSpecific.length; x++){
                        this.birSalesReports = siteSpecific[x].report_details
                        let reportData = [];
                        if(this.birSalesReports.length > 0){
                            let grouper = 'start'

                            let total_beg_bal = 0
                            let total_rr_cost = 0
                            let total_ti_cost = 0
                            let total_ret_cost = 0
                            let total_adji_cost = 0
                            let total_sales_cost = 0
                            let total_to_cost = 0
                            let total_pr_cost = 0
                            let total_adjo_cost = 0
                            
                            for(let i=0; i < this.birSalesReports.length; i++){
                                let reportLine = this.birSalesReports[i]
                                let grouper_name = reportLine.grouper_name

                                if (product_array.includes(reportLine.product_id) == false){
                                    product_array.push(reportLine.product_id)
                                }
                                
                                if(grouper == 'start'){
                                    let detail_header = [grouper_name];
                                    reportData.push(Object.assign({}, detail_header))
                                } else {
                                    if(grouper != reportLine.grouper_id){
                                        let detail_header = [grouper_name];
                                        reportData.push(Object.assign({}, detail_header))
                                    }
                                }
                                grouper = reportLine.grouper_id
                                
                                let detail = []
                                detail.push(
                                    reportLine.product_id,
                                    reportLine.barcode,reportLine.name,
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.retail_price)), 'Y'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.beg_bal)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.rr_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.ti_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.ret_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.adji_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.sales_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.to_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.pr_cost)), 'Z'),
                                    this.addMaskValidation(this.convertToCurrency(Number(reportLine.adjo_cost)), 'Z')
                                )
                                reportData.push(Object.assign({}, detail))

                                total_beg_bal += Number(reportLine.beg_bal)
                                total_rr_cost += Number(reportLine.rr_cost)
                                total_ti_cost += Number(reportLine.ti_cost)
                                total_ret_cost += Number(reportLine.ret_cost)
                                total_adji_cost += Number(reportLine.adji_cost)
                                total_sales_cost += Number(reportLine.sales_cost)
                                total_to_cost += Number(reportLine.to_cost)
                                total_pr_cost += Number(reportLine.pr_cost)
                                total_adjo_cost += Number(reportLine.adjo_cost)

                                grand_beg_bal += Number(reportLine.beg_bal)
                                grand_rr_cost += Number(reportLine.rr_cost)
                                grand_ti_cost += Number(reportLine.ti_cost)
                                grand_ret_cost += Number(reportLine.ret_cost)
                                grand_adji_cost += Number(reportLine.adji_cost)
                                grand_sales_cost += Number(reportLine.sales_cost)
                                grand_to_cost += Number(reportLine.to_cost)
                                grand_pr_cost += Number(reportLine.pr_cost)
                                grand_adjo_cost += Number(reportLine.adjo_cost)

                                if(i == this.birSalesReports.length-1){
                                    let total_detail = []

                                    let total_display = "Grand Total"
                                    if(this.isSeparateSite == true){
                                        total_display = "Site Sub Total"
                                    }

                                    if(this.isSeparateSite == false){
                                        total_detail.push(`Assortment : ${product_array.length}`)
                                    } else {
                                        total_detail.push("", "")
                                    }

                                    total_detail.push(
                                        `${total_display} :`, "",
                                        this.convertToCurrency(total_beg_bal),
                                        this.addMaskValidation(this.convertToCurrency(total_rr_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_ti_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_ret_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_adji_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_sales_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_to_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_pr_cost), 'Z'),
                                        this.addMaskValidation(this.convertToCurrency(total_adjo_cost), 'Z')
                                    )

                                    reportData.push(Object.assign({}, total_detail))
                                }
                            }
                        }

                        if(x == siteSpecific.length-1 && this.isSeparateSite == true){
                            let total_detail = []

                            total_detail.push(`Assortment : ${product_array.length}`, "",
                                "Grand Total :", "",
                                this.convertToCurrency(grand_beg_bal),
                                this.addMaskValidation(this.convertToCurrency(grand_rr_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_ti_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_ret_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_adji_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_sales_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_to_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_pr_cost), 'Z'),
                                this.addMaskValidation(this.convertToCurrency(grand_adjo_cost), 'Z')
                            )

                            reportData.push(Object.assign({}, total_detail))
                        }

                        let group_text = ""
                        if(this.inputGroupBy != ''){
                            group_text = " by " + group_val
                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        reportData.push(["Stock Activity Valuation" + group_text, "Generate By: " + printed_by,"For the Period of " + from_header + " to " + to_header])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                        	var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                              		[val]: values[i][index]
                            	  }
                              )
                            )
                          );
                          newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                          for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                              obj[i] = '';
                            }
                          }
                        });
                        site_specific.push(newJsonData)

                        // this.JsonData = site_specific;
                    }
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    this.openNotificationWithIcon('error', 'No Data.');
                }
                this.spinning= false;
            },
            clearJsonData(){
              // console.log("working",this.JsonData)
              this.JsonData = [];
            },
            addMaskValidation(value, rights){
                if((!this.accessCostPriceRights.includes('Z') && rights == 'Z') || (!this.accessCostPriceRights.includes('Y') && rights == 'Y')){
                    return '***';
                }else{
                    return value
                }
            }
        }
    };
</script>

<style></style>